import { BaseControlDef, BaseElementDefBase } from "./BaseElementDef";
import { Observable, ReplaySubject } from "rxjs";
import { share } from "rxjs/operators";
import { FormDefinitionItem } from "@/public/pages/elements/__DefinitionDataInterface";
import { CalculatedSettings } from "@cs-ts/calculated-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import { FormMultiControlItem } from "@/cs-ts-bridge/cs/FormMultiControlItem";

// TODO not really a control
export default class CalculatedDef extends BaseControlDef<CalculatedSettings, FormDefinitionItem<CalculatedSettings>, FormMultiControlItem, string[]> {
    declare _valueList$: Observable<string[]>;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormMultiControlItem, definitionData: FormDefinitionItem<CalculatedSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFCalculated"; // TODO - not hardcoded?
    }

    effectiveValueList$() {
        return this.valueList$();
    }

    valueList$() {
        if (this._valueList$ == null) {
            const result = this.resolveCalculation(this.definition.settings.calculationId!);
            //this._valueList$ = new ReplaySubject(1);
            //result.subscribe(this._valueList$);
            this._valueList$ = result.pipe(share({ resetOnRefCountZero: true, connector: () => new ReplaySubject(1) }));
        }
        return this._valueList$;
    }
}
